import { organizationEvent$ } from "../api/eventBus";
import { eventBusType } from "../config/Constant";

const searchOrganization = (orgList, name, existedMemberIds = [], setting) => {
  if (!setting) {
    if (!existedMemberIds) {
      existedMemberIds = ["3"];
    } else {
      existedMemberIds?.push("3");
    }
  }

  if (!existedMemberIds?.length && (!name || name === "")) {
    return orgList;
  }

  if (existedMemberIds?.length && (!name || name === "")) {
    return orgList?.filter(
      (org) =>
        !existedMemberIds?.includes(org?.objectId) &&
        !existedMemberIds?.includes(org?.parentId),
    );
  }

  return orgList?.filter(
    (org) =>
      !existedMemberIds?.includes(org?.objectId) &&
      !existedMemberIds?.includes(org?.parentId) &&
      (org?.name?.includes(name?.toUpperCase()) ||
        org?.objectId?.includes(name?.toUpperCase())),
  );
};

const getChildren = (orgList, parentIds, withoutObjectIds = []) => {
  return orgList?.filter(
    (org) =>
      !withoutObjectIds?.includes(org?.objectId) &&
      parentIds?.includes(org?.objectId),
  );
};

/** update for click to view detail -> userCode */
const updateOrg = (setOriginalOrgList, userOrg) => {
  setOriginalOrgList((prev) =>
    prev?.map((element) =>
      element?.userCode === userOrg?.userCode
        ? { ...element, online: userOrg?.online }
        : element,
    ),
  );

  organizationEvent$.next({
    type: eventBusType.USER_DETAIL_UPDATED,
    payload: userOrg,
  });
};

/** update for member list api -> userId */
const updateOrgList = (setOriginalOrgList, userOrgList) => {
  setOriginalOrgList((prev) =>
    prev?.map((element) => {
      const userOrg = userOrgList?.find((u) => u?.userId === element?.userCode);

      return userOrg ? { ...element, online: userOrg?.online } : element;
    }),
  );

  organizationEvent$.next({
    type: eventBusType.USER_LIST_UPDATED,
    payload: userOrgList,
  });
};

export { getChildren, searchOrganization, updateOrg, updateOrgList };
